import styles from '../Table/Table.module.css';
import { Table } from './Table';

interface Props {
  colSpan: number;
  text: string;
}

export function Empty({ text, colSpan }: Props) {
  return (
    <Table.Row>
      <Table.Col colSpan={colSpan}>
        <small className={styles.empty}>{text}</small>
      </Table.Col>
    </Table.Row>
  );
}
